import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const passwordMatch = (formControl: AbstractControl): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value === formControl.value
      ? null
      : { PASSWORDS_NOT_MATCH_ERROR: true };
  };
};
